import { t } from 'i18next';
import * as yup from 'yup';

const stringSchema = (name: string, length: number) =>
  yup
    .string()
    .typeError(t('validation.invalid', { name }))
    .required(t('validation.valueIsRequired'))
    .max(length, t('validationMaxCharacters', { name, number: length }));

export const schema = yup.object().shape({
  code: stringSchema(t('poolMaintenance.column.code'), 10),
  name: stringSchema(t('poolMaintenance.column.name'), 100),
  description: stringSchema(t('poolMaintenance.column.description'), 1000)
});
